export default {
  uname(state) {
    return state.uname;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  domain(state) {
    return state.domain;
  },
  fullname(state) {
    return state.fullname;
  },
  avatar(state) {
    return state.avatar;
  },
  permissions(state) {
    if (state.permissions) {
      return JSON.parse(JSON.stringify(state.permissions));
    }
    return [];
  },
  phoneInfo(state) {
    return JSON.parse(JSON.stringify(state.phoneInfo));
  },
  smsLogs(state) {
    return JSON.parse(JSON.stringify(state.smsLogs));
  },
  workPlace(state) {
    return state.workPlace;
  },
  workPhone(state) {
    return state.workPhone;
  },
  plugings(state) {
    return state.plugings;
  },
  usePhone(state) {
    return state.usePhone;
  },
  shortCodes(state) {
    return state.shortCodes;
  },
  skills(state) {
    if (state.skills) {
      return JSON.parse(JSON.stringify(state.skills));
    }
    return [];
  },
  type(state) {
    return state.type;
  },
  status(state) {
    return state.status;
  },
  restEndtime(state) {
    return state.restEndtime;
  },
  inCall(state) {
    return state.inCall;
  },
  isConnected(state) {
    return state.isConnected;
  },

  profile(state) {
    return JSON.parse(JSON.stringify(state.profile));
  },
  CRMInitInfo(state) {
    return JSON.parse(JSON.stringify(state.CRMInitInfo));
  },
  answerRequest(state) {
    return state.answerRequest;
  },
  holdRequest(state) {
    return state.holdRequest;
  },
  muteRequest(state) {
    return state.muteRequest;
  },
  hangupRequest(state) {
    return state.hangupRequest;
  },
  isAnswered(state) {
    return state.isAnswered;
  },
  isMute(state) {
    return state.isMute;
  },
  isHolding(state) {
    return state.isHolding;
  },
  isIncoming(state) {
    return state.isIncoming;
  },
  isOutgoing(state) {
    return state.isOutgoing;
  },
  sessionPeer(state) {
    return state.sessionPeer;
  },
  currentCall(state) {
    return state.currentCall;
  },
  inAcw(state) {
    return state.inAcw;
  },
  chatSocket(state) {
    return state.chatSocket;
  },
  socketKey(state) {
    return state.socketKey;
  },
  incomingSocketMessage(state) {
    return state.incomingSocketMessage;
  },
  incomingSocketOmniMessage(state) {
    return state.incomingSocketOmniMessage;
  },
  currentChatID(state) {
    return state.currentChatID;
  },
  currentOmniID(state) {
    return state.currentOmniID;
  },
  notReadChatMessages(state) {
    return JSON.parse(JSON.stringify(state.notReadChatMessages));
  },
  notReadOmniMessages(state) {
    return JSON.parse(JSON.stringify(state.notReadOmniMessages));
  },
  differentTABRead(state) {
    return JSON.parse(JSON.stringify(state.differentTABRead));
  },
  omniActiveConversations(state) {
    return JSON.parse(JSON.stringify(state.omniActiveConversations));
  },
  omniUsers(state) {
    return JSON.parse(JSON.stringify(state.omniUsers));
  },
  omniOpenedConversation(state) {
    return JSON.parse(JSON.stringify(state.omniOpenedConversation));
  },
  assistantChat(state) {
    return JSON.parse(JSON.stringify(state.assistantChat));
  },
  assistantAsk(state) {
    return JSON.parse(JSON.stringify(state.assistantAsk));
  },
  omniDifferentTABRead(state) {
    return JSON.parse(JSON.stringify(state.omniDifferentTABRead));
  },
  omniConversationClosed(state) {
    return JSON.parse(JSON.stringify(state.omniConversationClosed));
  },
  assignedOmniConversation(state) {
    return JSON.parse(JSON.stringify(state.assignedOmniConversation));
  },
  differentTABSent(state) {
    return JSON.parse(JSON.stringify(state.differentTABSent));
  },
  omniDifferentTABSent(state) {
    return JSON.parse(JSON.stringify(state.omniDifferentTABSent));
  },
  omniFailedMsg(state) {
    return JSON.parse(JSON.stringify(state.omniFailedMsg));
  },
  handleOpenedOmniConversation(state) {
    return JSON.parse(JSON.stringify(state.handleOpenedOmniConversation));
  },
  numberToCall(state) {
    return state.numberToCall;
  },
  omniCloseOverlay(state) {
    return state.omniCloseOverlay;
  },
  omniClosedCustomer(state) {
    return state.omniClosedCustomer;
  },
  callsList(state) {
    return JSON.parse(JSON.stringify(state.callsList));
  },
  acwSettings(state) {
    return JSON.parse(JSON.stringify(state.acwSettings));
  },
  acwStatus(state) {
    return JSON.parse(JSON.stringify(state.acwStatus));
  },
  crmLocalFields(state) {
    return JSON.parse(JSON.stringify(state.crmLocalFields));
  },
  ticketingLocalFields(state) {
    return JSON.parse(JSON.stringify(state.ticketingLocalFields));
  },
  isWhispering(state) {
    return state.isWhispering;
  },
  whisperedAgent(state) {
    return state.whisperedAgent;
  },
  whisperedChannel(state) {
    return state.whisperedChannel;
  },
};
